<template>
  <div class="left-zhu">
    <div class="header-top">
      <!--      <p class="header-logo"><img src="@/assets/images/shoujia.png"></p>-->
      <!--      <p class="header-logo"><img src="https://qiniu.sjhlwyy.com/S2024090516000005.png"></p>-->
      <p class="header-logo"><img src="https://qiniu.sjhlwyy.com/shenpi/temp/hxyt_logo.png" alt="惠心云审管理系统"></p>
    </div>

    <scroll-bar>
      <el-menu 
        mode="vertical" 
        :show-timeout="200" 
        :default-active="$route.path" 
        :collapse="isCollapse"
        background-color="transparent" 
        text-color="#ffffff" 
        active-text-color="#ffffff" 
        unique-opened
        class="topheader"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
    <!-- <div class="bottom-logo"> -->
    <!-- <div style="margin-top:20px">jinbai系统</div>  -->
    <!-- <div>版本：v1.0</div> -->
    <!-- </div>-->
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: {SidebarItem, ScrollBar},
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      userName: 'Zhwg',
      roleName: '店长'
    }
  }
}
</script>
<style lang="scss" scoped>
.left-zhu {
  position: relative;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.header-top {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .header-tou {
    margin-top: 5px;

    img {
      width: 100px;
      height: 100px;
      border-radius: 10px;
    }
  }

  .header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
      width: 120px;
      height: auto;
      max-height: 50px;
      object-fit: contain;
      filter: brightness(0) invert(1);
      transition: transform 0.3s;
      
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-xin {
    span {
      margin-right: 10px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
    }
  }
}

.bottom-logo {
  width: 100%;
  min-height: 60px;
  padding: 20px 0;

  div {
    width: 100%;
    height: 30px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue